import type { Flash as FlashType } from './flash.d';
import { StyledFlashText } from './flash.styles';

export const Flash = (props: { flash: FlashType }) => <StyledFlashText innerHTML={props.flash.text} />;
